// @flow
import i18n from 'app/common/lib/i18n';
import storage from 'app/common/lib/Storage';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import {
  type InterestObj,
  TOP_INTERESTS_FOR_US_FEMALE,
  TOP_INTERESTS_FOR_US_MALE,
} from 'app/common/react/components/growth/activation/NuxConst/NuxConst';

export default function doesContainObjectById(
  objectList: Array<Object>,
  newObject: Object,
): boolean {
  return objectList.some((object) => object.id === newObject.id);
}

export function getHostname(url: string): string {
  if (__SERVER__) {
    throw new Error(
      'The function getHostname from NuxUtils is supported only in a browser environment',
    );
  }

  const fullUrl = url.startsWith('http') ? url : `http://${url}`;

  try {
    return new window.URL(fullUrl).hostname;
  } catch (e) {
    const ele = document.createElement('a');
    ele.href = fullUrl;
    return ele.hostname;
  }
}

export const getWelcomeBackText = (firstName?: string): string =>
  firstName
    ? interpolateNamedTemplate(
        i18n._('Welcome back, {{ firstName }}!', 'Header on welcome step of renux'),
        { firstName },
      )
    : i18n._('Welcome back!', 'Header on welcome step of renux');

export function isDefaultProfileImage(url: string): boolean {
  // Match url that ends with /static/images/user/default_123.png where 123 can be any number
  return !!(url && url.match(/\/static\/images\/user\/default_\d+\.png$/));
}

export function topInterestsByGender(
  interests: Array<InterestObj>,
  gender: string,
): Array<InterestObj> {
  if (!interests) {
    return [];
  }
  const topInterests = gender === 'male' ? TOP_INTERESTS_FOR_US_MALE : TOP_INTERESTS_FOR_US_FEMALE;
  return interests.filter((item: InterestObj) => topInterests.includes(Number(item.id)));
}

export type VisitedPinPage = {|
  ts: number,
  path: string,
  id: number,
  image_signature: string,
  is_shared_pin: boolean,
|};

export type VisitedBoardPage = {|
  ts: number,
  board_id: number,
  first_pin_id: number,
  first_pin_image_signature: string,
|};

export type VisitedPages = Array<VisitedPinPage | VisitedBoardPage>;

export function getRecentSigs(visitedPages: VisitedPages): Array<string> {
  // Only consider pages visited within the last 2 hours
  const recentSigs = [];
  if (visitedPages) {
    const msInTwoHours = 2 * 60 * 60 * 1000;
    const timeCutoff = Date.now() - msInTwoHours;
    for (const page of visitedPages) {
      if (page.ts >= timeCutoff) {
        // plp has page.image_signature, blp has page.first_pin_image_signature
        if (typeof page.image_signature === 'string') {
          recentSigs.push(page.image_signature);
        }
        if (typeof page.first_pin_image_signature === 'string') {
          recentSigs.push(page.first_pin_image_signature);
        }
      }
    }
  }
  return recentSigs;
}

export type ExtraImageData = {|
  plpImages: Array<string>,
  blpImages: Array<string>,
|};

export function calculateTopicsInsertionData(): ExtraImageData {
  const visitedPlpsBeforeLogin = storage.localStorage.getItem(
    PCONST.LOCALSTORAGE_VISITED_PLPS_BEFORE_LOGIN,
  );
  const plpImages = getRecentSigs(visitedPlpsBeforeLogin);
  const visitedBlpsBeforeLogin = storage.localStorage.getItem(
    PCONST.LOCALSTORAGE_VISITED_BLPS_BEFORE_LOGIN,
  );
  const blpImages = getRecentSigs(visitedBlpsBeforeLogin);
  return {
    plpImages,
    blpImages,
  };
}
